import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { GridDataSource, LoaderService, NotificationService } from 'src/app/shared/session';
import { CONSTANT } from '../../../../shared/common/constant.service';
import { RegionOficinaService } from '../shared/region-oficina.service';

@Component({
  selector: 'app-region-oficina-list',
  templateUrl: './region-oficina-list.component.html',
})
export class RegionOficinaListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() titlePage: string;
  @Input() data: any;
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;

  pageSize: number;
  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(
    private loaderService: LoaderService,
    private regionOficinaService: RegionOficinaService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.msgErrorGet = 'Error al listar las Oficinas';
    this.displayedColumns = ['Relacionado', 'Oficina'];
  }

  searchEmit(data: any) {
    this.buscarRegionOficina(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  buscarRegionOficina(filtro: string) {
    this.listarRegionOficina(filtro);
  }

  listarRegionOficina(filtro: string) {
    this.loaderService.show();
    this.regionOficinaService.listarRegionOficina(filtro, this.data.region.id)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  onChangeVinculacion(row: any) {
    this.guardarRegionOficina(row.idOficina)
  }

  guardarRegionOficina(idOficina: number): void {
    this.loaderService.show();
    this.regionOficinaService.guardarRegionOficina(this.data.region.id, idOficina)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
